import { useEffect, useState } from "react";
import { buscarTotalDeContas } from "../../../services/busca-total-de-contas";
import { buscarTotalDePersonagens } from "../../../services/busca-total-de-personagens";
import './painel-esquerdo.component.scss';
import { alertService } from "../../../services/alertService";
import { retornarLinkLogo } from "../../../services/logoService";
import { ComunidadeDTO } from "../../../dtos/ComunidadeDTO";
import {
    armazenarComunidadesSession,
    buscarComunidades,
    obterComunidadesSession
} from "../../../services/busca-comunidades";
import { retornarStatusJogo } from "../../../services/statusJogo";
import { StatusJogoDTO } from "../../../dtos/StatusJogoDTO";
import { useTranslation } from "react-i18next";
import { FeatureFlag } from "../../../../feature-flag";
import LanguageSwitcher from "../../idioma-component/idioma-component";

const PainelEsquerdoComponent = () => {

    const { t } = useTranslation();

    const [totalContas, setTotalContas] = useState(0);
    const [totalPersonagens, setTotalPersonagens] = useState(0);
    const [linkLogo, setLinkLogo] = useState('./assets/Imagens/logo.png');
    const [comunidades, setComunidades] = useState<ComunidadeDTO>();
    const [status, setStatus] = useState<StatusJogoDTO>();
    const [modoSteamHabilitado, setModoSteamHabilitado] = useState(FeatureFlag.ModoSteamHabilitado);
    const [flagConsumo, setFlagConsumo] = useState(FeatureFlag.DesabilitaConsumoTotalDePersonagensEContas);
    const [flagStatus, setFlagStatus] = useState(FeatureFlag.DesabilitaStatusJogo);

    useEffect(() => {

        retornarLinkLogo()
            .then(setLinkLogo)
            .catch(console.error);

        if (!FeatureFlag.DesabilitaStatusJogo) {
            retornarStatusJogo()
                .then(setStatus)
                .catch(() => alertService.toast(t("LEFT_FETCH_STATUS_ERROR"), 'error'));
        }

        if (!FeatureFlag.DesabilitaConsumoTotalDePersonagensEContas) {
            buscarTotalDeContas()
                .then(setTotalContas)
                .catch(() => alertService.toast(t("LEFT_FETCH_ACCOUNTS_ERROR"), 'error'));

            buscarTotalDePersonagens()
                .then(setTotalPersonagens)
                .catch(() => alertService.toast(t("LEFT_FETCH_CHARACTERS_ERROR"), 'error'));
        }

        if (!obterComunidadesSession()) {
            buscarComunidades()
                .then((data) => {
                    setComunidades(data);
                    armazenarComunidadesSession(data);
                })
                .catch(() => alertService.toast(t("LEFT_FETCH_COMMUNITIES_ERROR"), 'error'));
        } else {
            setComunidades(obterComunidadesSession());
        }

    }, [t]);

    const irAteSteam = () => window.open('https://store.steampowered.com/app/4405770/Dreams_Stories_Online/');

    const irAtePainelDeUsuario = () => window.location.href = "#/painel";
    const irAteSuporte = () => window.open('https://suporte.dreamsstoriesonline.com/');
    const irAteUrl = (url: string) => window.open(url);

    return (
        <div>

            <div className="idioma ">
                <LanguageSwitcher />
            </div>


            <div className="situacao-do-jogo text-center col-12">

                <div className="container-infos-bd">
                    <img src={linkLogo} className="img-fluid logo" alt="Logo" />
                </div>
            </div>

            <div className="informacao-container-jogo">


                <div className="situacao-do-jogo text-center col-12">
                    <div className="container-infos-bd">
                        <h5>{t("DOWNLOAD_TITLE")}</h5>

                        <button onClick={irAteSteam} className="btn-menu botao-lateral col-12">
                            {t("DOWNLOAD_GO")}
                            <img src="./assets/Imagens/pirates_116_t.png" className="icone-menu" />
                        </button>


                    </div>
                </div>


                <div className="situacao-do-jogo text-center col-12" style={{ display: flagStatus ? 'none' : '' }}>
                    <div className="container-infos-bd">
                        <h5>{t("LEFT_STATUS_TITLE")}</h5>
                        <span
                            className={status?.Online === 1 ? 'online' : 'offline'}
                            style={{ fontFamily: 'Cursive' }}
                        >
                            {status?.Online === 1
                                ? t("LEFT_STATUS_ONLINE")
                                : t("LEFT_STATUS_OFFLINE")}
                        </span>
                    </div>
                </div>

                <div className="informacoes-do-jogo text-center col-12" style={{ display: flagConsumo ? 'none' : '' }}>
                    <div className="container-infos-bd">
                        <h5>{t("LEFT_GAME_INFO_TITLE")}</h5>
                        <span className="total-de-algo">
                            {t("LEFT_TOTAL_ACCOUNTS")} <span className="cor-resultado">{totalContas}</span>
                        </span>
                        <span className="total-de-algo">
                            {t("LEFT_TOTAL_CHARACTERS")} <span className="cor-resultado">{totalPersonagens}</span>
                        </span>
                    </div>
                </div>

                <div style={modoSteamHabilitado ? { display: 'none' } : { display: '' }} className="informacoes-do-jogo text-center col-12">
                    <div className="container-infos-bd">
                        <h5>{t("LEFT_CLIENT_AREA_TITLE")}</h5>
                        <button onClick={irAtePainelDeUsuario} className="btn-menu botao-lateral col-12">
                            {t("LEFT_USER_PANEL")}
                            <img src="./assets/Imagens/pirates_143_t.PNG" className="icone-menu" />
                        </button>
                    </div>
                </div>

                <div style={modoSteamHabilitado ? { display: 'none' } : { display: '' }} className="informacoes-do-jogo text-center col-12">
                    <div className="container-infos-bd">
                        <h5>{t("LEFT_SUPPORT_TITLE")}</h5>
                        <button onClick={irAteSuporte} className="btn-menu botao-lateral col-12">
                            {t("LEFT_REPORT_PROBLEM")}
                            <img src="./assets/Imagens/pirates_70_t.png" className="icone-menu" />
                        </button>
                    </div>
                </div>

                <div className="informacoes-do-jogo conteudos-menu text-center col-12">
                    <h5>{t("LEFT_COMMUNITY_TITLE")}</h5>

                    <button onClick={() => irAteUrl(comunidades?.Youtube || '')} className="btn-menu botao-lateral col-12">
                        {t("LEFT_COMMUNITY_YOUTUBE")}
                        <img src="./assets/Imagens/icone-youtube.png" className="icone-menu" />
                    </button>

                    <button onClick={() => irAteUrl(comunidades?.Discord || '')} className="btn-menu botao-lateral col-12">
                        {t("LEFT_COMMUNITY_DISCORD")}
                        <img src="./assets/Imagens/icone-discord.png" className="icone-menu" />
                    </button>

                    <button onClick={() => irAteUrl(comunidades?.Facebook || '')} className="btn-menu botao-lateral col-12">
                        {t("LEFT_COMMUNITY_FACEBOOK")}
                        <img src="./assets/Imagens/icone-facebook.png" className="icone-menu" />
                    </button>

                    <button onClick={() => irAteUrl(comunidades?.Instagram || '')} className="btn-menu botao-lateral col-12">
                        {t("LEFT_COMMUNITY_INSTAGRAM")}
                        <img src="./assets/Imagens/icone-instagram.png" className="icone-menu" />
                    </button>
                </div>

                <div className="informacoes-do-jogo conteudos-menu text-center col-12 parceiro-destaque" style={modoSteamHabilitado ? { display: 'none' } : { display: '' }}>
                    <h5 className="titulo-parceria">{t("LEFT_PARTNERS_TITLE")}</h5>

                    <div className="parceiro-card">
                        <img
                            onClick={() => irAteUrl('https://vault.imersa.art/')}
                            src="./assets/Imagens/parceiro_01.svg"
                            className="parceiro-svg"
                        />
                        <span className="parceiro-texto">
                            {t("LEFT_PARTNER_TEXT")}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export { PainelEsquerdoComponent };
